var _path, _path2, _g, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChestF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 181,
    viewBox: "0 0 212 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1992 6.24148C71.4221 5.42489 73.0478 5.41534 74.9801 5.91303C75.921 18.326 87.6617 24.9865 106.088 24.9865C124.321 24.9865 136.106 18.4675 137.272 6.30576C138.432 5.70692 141.515 5.38532 142.789 6.65463C142.789 6.65785 142.789 6.66108 142.789 6.6643C151.326 9.44539 159.892 12.3777 167.256 14.8987C170.616 16.049 173.727 17.1138 176.47 18.0394C192.387 23.4107 201.959 68.1358 205.64 99.0204C201.153 103.513 188.813 109.059 164.672 109.059C164.672 111.296 164.614 127.996 164.556 144.771L164.556 144.783L164.556 144.827C164.497 161.737 164.439 178.707 164.439 181.001H106.001H47.7224C47.7224 178.705 47.6099 161.814 47.4979 144.995L47.4979 144.991C47.3869 128.315 47.2763 111.709 47.2763 109.473C23.1357 109.473 10.8482 103.513 6.36133 99.0204C10.0429 68.1358 19.6142 23.4107 35.5321 18.0394C38.275 17.1138 41.3849 16.0492 44.745 14.899C52.3933 12.2807 61.3377 9.21874 70.1995 6.34332C70.1993 6.3094 70.1992 6.27545 70.1992 6.24148Z",
    fill: "#9A9A9A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_725_48992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 200,
    height: 177
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1992 6.24197C71.4221 5.42538 73.0478 5.41583 74.9801 5.91352C75.921 18.3265 87.6617 24.987 106.088 24.987C124.321 24.987 136.106 18.468 137.272 6.30624C138.432 5.70741 141.515 5.38581 142.789 6.65512C142.789 6.65834 142.789 6.66157 142.789 6.66479C151.326 9.44588 159.892 12.3782 167.256 14.8992C170.616 16.0495 173.727 17.1143 176.47 18.0399C192.387 23.4112 201.959 68.1363 205.64 99.0209C201.153 103.514 188.813 109.06 164.672 109.06C164.672 111.296 164.614 127.996 164.556 144.772L164.556 144.783L164.556 144.827C164.497 161.737 164.439 178.708 164.439 181.001H106.001H47.7224C47.7224 178.706 47.6099 161.815 47.4979 144.995L47.4979 144.991C47.3869 128.315 47.2763 111.71 47.2763 109.473C23.1357 109.473 10.8482 103.514 6.36133 99.0209C10.0429 68.1363 19.6142 23.4112 35.5321 18.0399C38.275 17.1143 41.3849 16.0497 44.745 14.8994C52.3933 12.2812 61.3377 9.21923 70.1995 6.34381C70.1993 6.30989 70.1992 6.27594 70.1992 6.24197Z",
    fill: "#D3D3D3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_725_48992)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: -11,
    width: 83,
    height: 215,
    fill: "#464646"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3301 110.636C23.1689 110.636 9.52337 104.121 5.03262 99.592C4.62366 97.5248 5.06676 93.4465 6.1173 91.2671C11.8307 96.2862 29.0639 100.636 47.0698 101.155L47.3301 110.636Z",
    fill: "#9A9A9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.65 109.928C189.006 109.928 202.175 104.91 206.702 100.381C207.527 98.7236 207.114 93.3383 205.877 91.2671C200.117 96.2862 183.213 100.727 165.062 101.246L164.65 109.928Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestF);
export default __webpack_public_path__ + "static/media/Chest F.c16027daa900f4a479dca2ff401f3353.svg";
export { ForwardRef as ReactComponent };